<template>
  <form @submit.prevent="handleSubmit">
    <div class="form-group">
      <div
        class="alert text-left formatted-text"
        :class="{
          'alert-danger': message.error,
          'alert-success': !message.error,
        }"
        role="alert"
        v-show="message.display"
      >
        {{ this.message.content }}
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group row">
          <label for="lastname" class="col-md-4">Nom:</label>
          <input
            v-model="wanted.lastname"
            type="text"
            class="form-control col-md-8"
            :class="{ 'is-invalid': submitted && !wanted.lastname }"
            id="lastname"
            placeholder="Nom"
            name="lastname"
          />
        </div>

        <div class="form-group row">
          <label for="firstname" class="col-md-4">Prénom:</label>
          <input
            v-model="wanted.firstname"
            type="text"
            class="form-control col-md-8"
            :class="{ 'is-invalid': submitted && !wanted.firstname }"
            id="firstname"
            placeholder="Prénom"
            name="firstname"
          />
        </div>
        <div class="form-group row">
          <label for="email" class="col-md-4">Sexe:</label>
          <select
            id="statut"
            class="form-control col-md-8"
            :class="{ 'is-invalid': submitted && !wanted.gender }"
            v-model="wanted.gender"
          >
            <option disabled value="">Sélectionner le sexe...</option>
            <option v-for="s in sexes" :value="s.value" :key="s.id">
              {{ s.label }}
            </option>
          </select>
        </div>
        <div class="form-group row">
          <label for="birthdate" class="col-md-4">Date naissance:</label>
          <!-- <input
            v-model="wanted.birth_date"
            type="date"
            class="form-control col-md-8"
            :class="{ 'is-invalid': submitted && !wanted.birth_date }"
            id="birthdate"
            placeholder="Date de naissance"
            name="birthdate"
          /> -->
          <VueCtkDateTimePicker
            name="birthdate"
            class="col-md-8 ml-0 mr-0 pl-0 pr-0"
            v-model="wanted.birth_date"
            label="date de naissance"
            color="#0a3764"
            button-color="#0a3764"
            locale="fr"
            input-size="sm"
            format="YYYY-MM-DD"
            button-now-translation="Aujourd'hui"
            :error="submitted && !wanted.birth_date ? true : false"
            :only-date="true"
          />
        </div>
        <div class="form-group row">
          <label for="birthplace" class="col-md-4">Lieu de naissance:</label>
          <input
            v-model="wanted.birth_place"
            type="text"
            class="form-control col-md-8"
            id="birthplace"
            placeholder="Lieu de naissance"
            name="birthplace"
          />
        </div>
        <div class="form-group row">
          <label for="contact" class="col-md-4">Téléphone:</label>
          <input
            v-model="wanted.contact"
            type="text"
            class="form-control col-md-8"
            id="contact"
            placeholder="Téléphone"
            name="contact"
          />
        </div>
        <div class="form-group row">
          <label for="adresse" class="col-md-4">Adresse:</label>
          <input
            v-model="wanted.adress"
            type="text"
            class="form-control col-md-8"
            id="adresse"
            placeholder="Adresse"
            name="adresse"
          />
        </div>
        <div class="form-group row">
          <label for="document_number" class="col-md-4">Numéro document:</label>
          <input
            v-model="wanted.document_number"
            type="text"
            class="form-control col-md-8"
            id="document_number"
            placeholder="Numéro document"
            name="document_number"
          />
        </div>
        <div class="form-group row">
          <label for="citizenship_country" class="col-md-4">Nationalité:</label>
          <v-select
            id="citizenship_country"
            class="col-md-8"
            v-model="wanted.citizenship_country"
            :options="countries"
            label="name"
            :reduce="(country) => country.id"
            style="padding: 0"
          >
          </v-select>
        </div>
        <div class="form-group row">
          <label for="purpose" class="col-md-4">Motif</label>
          <textarea
            v-model="wanted.purpose"
            name="purpose"
            class="form-control col-md-8"
            id="purpose"
            rows="4"
            placeholder="Motif"
          ></textarea>
        </div>
        <div class="form-group row">
          <label class="col-md-2"></label>
          <div class="col-md-8">
            <button type="submit" class="btn btn-primary">Enrégister</button>
            <router-link
              class="btn btn-dark action-btn-cancel"
              :to="{ name: 'wanteds' }"
            >
              Retourner
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters } from "vuex";

import { CREATE_WANTED, FETCH_COUNTRIES } from "@/store/actions.type";
import { SET_LOADING } from "@/store/mutations.type";
import { SUCCESS_MESSAGE } from "@/helpers/messages";

import vSelect from "vue-select";

export default {
  name: "WantedForm",
  components: {
    vSelect,
  },
  data() {
    return {
      wanted: {
        firstname: "",
        lastname: "",
        gender: "",
        birth_date: "",
        birth_place: "",
        adress: "",
        contact: "",
        document_number: "",
        purpose: "",
        citizenship_country: "",
      },
      sexes: [
        { id: 1, label: "Masculin", value: "male" },
        { id: 2, label: "Féminin", value: "female" },
      ],
      submitted: false,
      message: {
        error: false,
        display: false,
        content: "",
      },
      errors: {},
    };
  },
  async mounted() {
    await this.getCountries();
  },
  computed: {
    ...mapGetters(["countries"]),
  },
  methods: {
    handleSubmit() {
      // affichage réinitialisé
      this.message.display = false;

      this.submitted = true;

      const { firstname, lastname, gender, birth_date } = this.wanted;
      if (!firstname || !lastname || !gender || !birth_date) {
        return;
      }

      this.$store.commit(SET_LOADING, true);

      this.$store
        .dispatch(CREATE_WANTED, this.wanted)
        .then(() => {
          this.message.content = SUCCESS_MESSAGE;
          this.message.display = true;
          this.message.error = false;

          //On réinitialise l'état
          this.wanted = {
            firstname: "",
            lastname: "",
            gender: "",
            birth_date: "",
            birth_place: "",
            adress: "",
            contact: "",
            document_number: "",
            purpose: "",
            citizenship_country: "",
          };
          this.submitted = false;
        })
        .catch((error) => {
          this.errors = error.errors;
          this.message.content = `${error} \n ${JSON.stringify(error.errors)}`;
          this.message.display = true;
          this.message.error = true;
          this.submitted = false;
        })
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
    getCountries() {
      this.$store.commit(SET_LOADING, true);
      this.$store
        .dispatch(FETCH_COUNTRIES)
        .catch(() => {})
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
  },
};
</script>

<style lang="scss">
@import "vue-select/src/scss/vue-select.scss";
.vs__dropdown-toggle {
  height: 38px;
}
</style>

<style lang="scss" scoped>
.form-group {
  display: flex;
  align-items: center;
}
label {
  margin-bottom: unset !important;
}
</style>